import ModalPortal from '@/components/ModalPortal/ModalPortal';
import { BreakPoint } from '@/hooks/useBreakPoint/consts';
import useIsMobile from '@/hooks/useIsMobile/useIsMobile';
import { Align } from '@uikit/types';
import { BoxWidth } from '../Box/consts';
import Button from '../Button/Button';
import { ShowIcon, ButtonColor, ButtonSize } from '../Button/consts';
import { ClickableAction } from '../Clickable/consts';
import { ContainerChildrenSpace } from '../Container/consts';
import Container from '../Container/Container';
import { HeadlineLevel, HeadlineColor } from '../Headline/consts';
import ModalCloseIcon from '../Modal/ModalCloseIcon/ModalCloseIcon';
import ModalContent from '../Modal/ModalContent';
import ModalHeader from '../Modal/ModalHeader';
import RichText from '../RichText/RichText';
import Spacer from '../Spacer/Spacer';
import type { JobDetailsHybridModalProps } from './interfaces';
import styles from './JobDetailsHybridModal.module.scss';

const BASE_BUTTON_PROPS = {
  size: ButtonSize.Medium,
  color: ButtonColor.Primary,
  showIcon: ShowIcon.ShowIcon,
  className: styles.button,
};

const APPLY_BUTTON_LABEL_EMAIL = 'E-Mail-Bewerbung';
const APPLY_BUTTON_LABEL_EXTERNAL = 'Online-Bewerbung';

const JobDetailsHybridModal = ({
  isOpen,
  handleClose,
  externalLink,
  emailTarget,
}: JobDetailsHybridModalProps) => {
  const isMobile = useIsMobile(BreakPoint.LG);

  return (
    <ModalPortal
      id="hybrid-modal"
      show={isOpen}
      onClose={handleClose}
      disableCloseIcon={true}
      variant="shade"
    >
      <ModalContent width={BoxWidth.SMedium}>
        <ModalCloseIcon onClick={handleClose} />
        <Container
          align={Align.Center}
          spaceBetweenChildren={ContainerChildrenSpace.None}
        >
          <ModalHeader
            headline="Du hast die Wahl"
            headlineLevel={HeadlineLevel.Four}
            headlineColor={HeadlineColor.Dark}
          />

          <Spacer defaultSize={1} />

          <RichText align={isMobile ? 'center' : 'left'} size="small">
            Auf welchem Weg möchtest du dich bewerben?
          </RichText>

          <Spacer defaultSize={1.5} md={2} />

          <Container
            className={styles.modalButtonWrapper}
            spaceBetweenChildren={ContainerChildrenSpace.None}
          >
            <Button
              actionType={ClickableAction.Linkextern}
              linkextern={externalLink}
              icon={'user/pen'}
              {...BASE_BUTTON_PROPS}
            >
              {APPLY_BUTTON_LABEL_EXTERNAL}
            </Button>
            <Button
              actionType={ClickableAction.MailTo}
              email={emailTarget || ''}
              icon={'user/mail'}
              color={ButtonColor.Secondary}
            >
              {APPLY_BUTTON_LABEL_EMAIL}
            </Button>
          </Container>
        </Container>
      </ModalContent>
    </ModalPortal>
  );
};

export default JobDetailsHybridModal;
